<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<div class="container mb-9">
  <div class="columns">
    <div class="column">
      <h1 class="title is-2 has-text-weight-bold has-line">Page not found</h1>
      <h2 class="is-size-7 is-uppercase has-font-weight-bold mb-4">
        Error 404
      </h2>
      <p>Sorry you landed on this error page</p>
      <p>Please use the navigation to find what you were looking for.</p>
    </div>
  </div>
</div>
